<div
  class="border-2 border-transparent flex-1 rounded-2xl h-full overflow-hidden transition-all duration-300"
  [class.speaking]="data().isSpeaking"
>
  <div class="w-full h-full bg-call-video relative flex justify-center flex-col items-center">
    <div
      class="video-header absolute top-3 left-4 right-4 z-10 gap-1 flex items-center justify-end"
      [class.justify-between]="data().isShareScreen"
    >
      @if (data().isShareScreen) {
        <button
          class="glass-button rounded-full overflow-hidden p-2 px-3 flex items-center justify-center"
        >
          <span class="owner-name !text-white font-semibold !text-xs">Đang trình chiếu</span>
        </button>
      }
      @if (data().videoId !== 'local-video' && !data().micOn) {
        <div class="h-8 w-8 shrink-0 bg-white flex justify-center items-center rounded-full">
          <app-icon name="meeting/mic-off-icon" [size]="16" svgClass="text-[--color-text-error]" />
        </div>
      }
    </div>

    <!-- Video Element Container -->
    <div
      class="h-full w-full overflow-hidden"
      [id]="data().videoId"
      [class.hidden]="!data().camOn"
    ></div>

    <!-- Fallback Avatar -->
    @if (!data().camOn) {
      <div class="relative w-fit">
        <div class="custom-ring r1" [class.hidden]="!data().isSpeaking"></div>
        <div class="custom-ring r2" [class.hidden]="!data().isSpeaking"></div>

        <app-avatar
          [id]="data().id"
          [size]="data().avatarSize ?? 96"
          [url]="data().avatar"
          [name]="data().name"
          [isDevice]="data().device"
        />
      </div>
    }

    <!-- Footer Status -->
    <div
      class="video-footer absolute bottom-3 left-4 z-10 text-white flex items-center bg-black/40 px-3 py-1 rounded-full"
    >
      @if (data().micOn) {
        <app-sound-icon [volume]="data().volume"></app-sound-icon>
      }
      <h4 class="owner-name !text-white ml-2 text-sm font-medium">{{ data().label }}</h4>
      @if (data().device) {
        <app-tammi-device-badge variant="icon-outline-dark" class="ml-2" />
      }
    </div>
  </div>
</div>
